import { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface DevModeContextValue {
  devMode: boolean;
  isLoading: boolean;
}

const DevModeContext = createContext<DevModeContextValue | null>(null);

export function DevModeContextProvider({ children }: { children: ReactNode }) {
  const [devMode, setDevMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDevMode = async () => {
      try {
        const response = await fetch("/api/config/devmode");
        if (response.ok) {
          const data = await response.json();
          setDevMode(data.devMode === true);
        }
      } catch (error) {
        console.error("Failed to fetch dev mode:", error);
        // Default to false if fetch fails
      } finally {
        setIsLoading(false);
      }
    };

    fetchDevMode();
  }, []);

  return (
    <DevModeContext.Provider value={{ devMode, isLoading }}>
      {children}
    </DevModeContext.Provider>
  );
}

export function useDevMode(): DevModeContextValue {
  const ctx = useContext(DevModeContext);
  if (!ctx) {
    throw new Error("useDevMode must be used within a DevModeContextProvider");
  }
  return ctx;
}
